import { render, staticRenderFns } from "./form-sad.vue?vue&type=template&id=09fa2fbf&scoped=true&"
import script from "./form-sad.vue?vue&type=script&lang=js&"
export * from "./form-sad.vue?vue&type=script&lang=js&"
import style0 from "./form-sad.vue?vue&type=style&index=0&id=09fa2fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa2fbf",
  null
  
)

export default component.exports